export const CHART_SCORE = [
  {
    id: 1,
    name: 'company',
    color: '#006AA6',
    dataKey: 'data1',
    dataFloatBar: 'dataFloatBar1',
    colorBar: 'rgba(0, 106, 166, 0.15)',
  },
  {
    id: 2,
    name: 'defaultVsicId',
    color: '#4EB1CB',
    dataKey: 'data2',
    dataFloatBar: 'dataFloatBar2',
    colorBar: 'rgba(78, 177, 203, 0.15)',
  },
  {
    id: 3,
    name: 'compareVsicId',
    color: '#F49966',
    dataKey: 'data3',
    dataFloatBar: 'dataFloatBar3',
    colorBar: 'rgba(244, 153, 102, 0.15)',
  },
]

export const SCORE_TABS = {
  credit: {
    label: 'companyAnalysis.industryAnalysis.CREDIT_RISK_SCORE',
    key: 'credit',
  },
  performance: {
    label: 'companyAnalysis.industryAnalysis.PERFORMANCE_SCORE',
    key: 'performance',
  },
}

export const PERIOD_TYPE = {
  yearly: {
    label: 'companyAnalysis.industryAnalysis.YEARLY',
    value: 'Yearly',
    isI18n: true,
  },
  quarterly: {
    label: 'companyAnalysis.industryAnalysis.QUARTERLY',
    value: 'Quarterly',
    isI18n: true,
  },

  monthly: {
    label: 'companyAnalysis.industryAnalysis.MONTHLY',
    value: 'Monthly',
    isI18n: true,
  },
}
